<template>
  <v-container id="docForm" style="max-width: 1500px">
    <!-- first card -->
    <v-card>
      <v-toolbar dense flat color="secondary">
        <v-toolbar-title>Order Creation</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <span style="font-weight: bold; font-size: 16px">Select Category to see products</span>
          </v-col>

          <v-col cols="12" md="4" v-for="category in categories" v-bind:key="category.id">
            <v-btn
            dark
              :to="`/customer/order/${category.id}`"
              color="blue-grey darken-2"
              style="padding: 20px; width: 250px;"
            >{{category.Name}}</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
// import Editor from "../_components/editor.vue";
export default {
  components: {
    //Editor,
  },
  data: () => ({
    dataItem: {},
    docCreate: true,
    categories: []
  }),
  methods: {
    save(data) {
      const url = "/documents";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.$router.push("/pending/orders");
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getCategories() {
      const self = this;
      this.$store
        .dispatch("get", `/products-categories`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.categories = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.getCategories();
  }
};
</script>